// import axios from 'axios';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
//   headers: { 'Content-Type': 'application/json' },
//   timeout: 120_000, // 2 min — Claude can take time on large reports
// });

// // Attach JWT to every request
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem('token');
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// // Global 401 handler — clear session and redirect to login
// // (skips the login endpoint itself, since a wrong password legitimately
// // returns 401 and should be handled locally, not force-reload the page)
// api.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     const isLoginRequest = err.config?.url?.includes('/auth/login');
//     if (err.response?.status === 401 && !isLoginRequest) {
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       window.location.href = '/login';
//     }
//     return Promise.reject(err);
//   }
// );


// // ── Simple in-memory cache ────────────────────────────────────
// const cache = new Map();
// const CACHE_TTL = 30_000; // 30 seconds

// function cachedGet(key, fn) {
//   const hit = cache.get(key);
//   if (hit && Date.now() - hit.ts < CACHE_TTL) return Promise.resolve({ data: hit.data });
//   return fn().then(res => {
//     cache.set(key, { data: res.data, ts: Date.now() });
//     return res;
//   });
// }

// export function invalidateCache(key) {
//   if (key) cache.delete(key);
//   else cache.clear();
// }

// export const authAPI = {
//   register: (data) => api.post('/auth/register', data),
//   login:    (data) => api.post('/auth/login',    data),
//   logout:   ()     => api.post('/auth/logout'),
//   changePassword: (data) => api.post('/auth/change-password', data),
// };

// export const modalitiesAPI = {
//   getAll: () => api.get('/modalities'),
// };

// export const bodyPartsAPI = {
//   getAll: () => api.get('/body-parts'),
// };

// // Instructions — pass `type` so the backend knows which table to use
// export const instructionsAPI = {
//   getAll:  (params)   => api.get('/instructions',      { params }),
//   create:  (data)     => api.post('/instructions',     data),
//   update:  (id, data) => api.put(`/instructions/${id}`, data),
//   delete:  (id, type) => api.delete(`/instructions/${id}`, { params: { type } }),
// };

// export const reportsAPI = {
//   getAll:   (params)   => cachedGet(`reports-${JSON.stringify(params)}`, () => api.get('/reports', { params })),
//   getStats: ()         => cachedGet('reports-stats', () => api.get('/reports/stats')),
//   getById:  (id)       => cachedGet(`report-${id}`, () => api.get(`/reports/${id}`)),
//   convert:  (data)     => api.post('/reports/convert', data).then(r => { invalidateCache(); return r; }),
//   update:   (id, data) => api.put(`/reports/${id}`, data).then(r => { invalidateCache(); return r; }),
//   delete:   (id)       => api.delete(`/reports/${id}`).then(r => { invalidateCache(); return r; }),
// };

// export const feedbackAPI = {
//   submit: (formData) => api.post('/feedback', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
//   getAll: ()         => api.get('/feedback'),
// };

// export default api;


import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  headers: { 'Content-Type': 'application/json' },
  timeout: 120_000, 
});

export const SESSION_MAX_AGE_MS = 2 * 24 * 60 * 60 * 1000; 

function sessionExpired() {
  const loginAt = Number(localStorage.getItem('login_at'));
  return !loginAt || (Date.now() - loginAt) > SESSION_MAX_AGE_MS;
}

api.interceptors.request.use((config) => {
  if (sessionExpired() && localStorage.getItem('token')) {
    clearSession();
    if (window.location.pathname !== '/login') window.location.href = '/login';
    return Promise.reject(new axios.Cancel('Session expired'));
  }
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function clearSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  localStorage.removeItem('login_at');
  try {
    sessionStorage.removeItem('converter_form');
    sessionStorage.removeItem('converter_final');
    sessionStorage.removeItem('converter_report_id');
  } catch {}
  invalidateCache();
}

let isRefreshing = false;
let refreshQueue = [];

function resolveRefreshQueue(error, token) {
  refreshQueue.forEach(({ resolve, reject }) => (error ? reject(error) : resolve(token)));
  refreshQueue = [];
}

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;
    const url = originalRequest?.url || '';
    const isAuthRequest = url.includes('/auth/login') || url.includes('/auth/refresh');

    if (err.response?.status !== 401 || isAuthRequest || originalRequest?._retry) {
      if (err.response?.status === 401 && !isAuthRequest) {
        clearSession();
        window.location.href = '/login';
      }
      return Promise.reject(err);
    }

    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken || sessionExpired()) {
      clearSession();
      window.location.href = '/login';
      return Promise.reject(err);
    }

    originalRequest._retry = true;

    if (isRefreshing) {
      
      return new Promise((resolve, reject) => {
        refreshQueue.push({ resolve, reject });
      }).then((newToken) => {
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest);
      });
    }

    isRefreshing = true;
    try {
      const { data } = await api.post('/auth/refresh', { refresh_token: refreshToken });
      localStorage.setItem('token', data.token);
      localStorage.setItem('refresh_token', data.refresh_token);
      localStorage.setItem('user', JSON.stringify(data.user));
      resolveRefreshQueue(null, data.token);
      originalRequest.headers.Authorization = `Bearer ${data.token}`;
      return api(originalRequest);
    } catch (refreshErr) {
      resolveRefreshQueue(refreshErr, null);
      clearSession();
      window.location.href = '/login';
      return Promise.reject(refreshErr);
    } finally {
      isRefreshing = false;
    }
  }
);


const cache = new Map();
const CACHE_TTL = 30_000; 

function cachedGet(key, fn) {
  const hit = cache.get(key);
  if (hit && Date.now() - hit.ts < CACHE_TTL) return Promise.resolve({ data: hit.data });
  return fn().then(res => {
    cache.set(key, { data: res.data, ts: Date.now() });
    return res;
  });
}

export function invalidateCache(key) {
  if (key) cache.delete(key);
  else cache.clear();
}

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login:    (data) => api.post('/auth/login',    data),
  refresh:  (refresh_token) => api.post('/auth/refresh', { refresh_token }),
  logout:   ()     => api.post('/auth/logout'),
  changePassword: (data) => api.post('/auth/change-password', data),
};

export const modalitiesAPI = {
  getAll: () => cachedGet('modalities', () => api.get('/modalities')),
};

export const bodyPartsAPI = {
  getAll: () => cachedGet('body-parts', () => api.get('/body-parts')),
};

export const instructionsAPI = {
  getAll:  (params)   => api.get('/instructions',      { params }),
  create:  (data)     => api.post('/instructions',     data),
  update:  (id, data) => api.put(`/instructions/${id}`, data),
  delete:  (id, type) => api.delete(`/instructions/${id}`, { params: { type } }),
};

export const reportsAPI = {
  getAll:   (params)   => cachedGet(`reports-${JSON.stringify(params)}`, () => api.get('/reports', { params })),
  getStats: ()         => cachedGet('reports-stats', () => api.get('/reports/stats')),
  getById:  (id)       => cachedGet(`report-${id}`, () => api.get(`/reports/${id}`)),
  convert:  (data)     => api.post('/reports/convert', data).then(r => { invalidateCache(); return r; }),
  update:   (id, data) => api.put(`/reports/${id}`, data).then(r => { invalidateCache(); return r; }),
  delete:   (id)       => api.delete(`/reports/${id}`).then(r => { invalidateCache(); return r; }),
};

export const feedbackAPI = {
  submit: (formData)      => api.post('/feedback', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
       .then(r => { invalidateCache('feedback'); return r; }),
    getAll: ()               => api.get('/feedback'),
  remove: (reportId, createdAt) =>
    api.delete(`/feedback/${reportId}`, { params: { created_at: createdAt } })
       .then(r => { invalidateCache(); return r; }),
};

export const notificationsAPI = {
  getAll:          ()   => api.get('/notifications'),
  getUnreadCount:  ()   => api.get('/notifications/unread-count'),
  markRead:        (id) => api.patch(`/notifications/${id}/read`),
  markAllRead:     ()   => api.patch('/notifications/read-all'),
};

export default api;